export const ssoExists = (response) => {
  return (
    response.ssoExist === true
    && response.accounts
    && Array.isArray(response.accounts)
    && response.accounts.length >= 1
  );
};

export const getDefaultCard = (accounts) => {
  const defaultCards = accounts.filter(
    (account) => account.defaultCard === true
  );
  const consumerDefaultCard = defaultCards.filter(
    (account) => account.accountType === 'PLCN_HOMEDEPOT'
  );
  if (consumerDefaultCard.length > 0) {
    return consumerDefaultCard[0];
  }
  if (defaultCards.length > 0) {
    return defaultCards[0];
  }
  return accounts[0];
};

export const unauthorizedError = (response) => {
  return (
    response.errors
    && Array.isArray(response.errors)
    && response.errors[0].errorCode === 'AUTH_ERR_105'
  );
};

export const isErrorResponse = (response) => {
  return (
    response.ssoExist === false
    && response.errors
    && response.errors.errors
    && Array.isArray(response.errors.errors)
  );
};

export const accountUnlinkedDueToInactivity = (response) => {
  return (
    response.ssoExist === false
    && response.accounts
    && Array.isArray(response.accounts)
    && response.accounts[0].errors
    && Array.isArray(response.accounts[0].errors.errors)
    && response.accounts[0].errors.errors[0].errorCode === 'SSO_CITI_401'
  );
};

export const plccCardSaved = (plccCardResponse, cardType) => {
  let plccCardExists = false;

  if (plccCardResponse.savedCards && plccCardResponse.savedCards.length >= 1) {
    const plccCard = plccCardResponse.savedCards.filter((card) => {
      return card === cardType;
    });
    if (plccCard.length >= 1) plccCardExists = true;
  }

  return plccCardExists;
};

export const defaultCard401CitiError = (defaultCard) => {
  return (
    defaultCard.errors
    && defaultCard.errors.errors
    && Array.isArray(defaultCard.errors.errors)
    && defaultCard.errors.errors[0].errorCode === 'SSO_CITI_401'
  );
};

export const cardImageUrl = {
  PLCN_HOMEDEPOT: 'https://assets.thdstatic.com/images/v1/plcc-credit-card.png',
  PLNP_HOMEDEPOT:
    'https://assets.thdstatic.com/images/v1/plcc-prox-credit-card.png',
  PLCR_HOMEDEPOT:
    'https://assets.thdstatic.com/images/v1/plcc-commercial-revolving-credit-card.png',
};

export const creditCardTypeText = {
  PLCN_HOMEDEPOT: 'Consumer Card',
  PLNP_HOMEDEPOT: 'Commercial Account',
  PLCR_HOMEDEPOT: 'Commercial Revolving Charge',
};

export const isCommercial = (accountType) => {
  return accountType === 'PLNP_HOMEDEPOT' || accountType === 'PLCR_HOMEDEPOT';
};

export const defaultURL = {
  PLCN_HOMEDEPOT:
    'https://citiretailservices.citibankonline.com/RSnextgen/svc/launch/index.action'
    + '?siteId=PLCN_HOMEDEPOT#signon&cmp=A~C~C~M~Z~Z~ZZZZ~ZZ~HD~ZZ&desc=R~A~I~Z~Z~Z~ZZZZ~ZZ~HD',
  PLNP_HOMEDEPOT:
    'https://www.retailservicescommercial.citi.com/USCRSF/CMLSVC/index.html?siteId=PLNP_HOMEDEPOT#sec/signon',
  PLCR_HOMEDEPOT:
    'https://www.retailservicescommercial.citi.com/USCRSF/CMLSVC/index.html?siteId=PLCR_HOMEDEPOT#sec/signon',
};

export const analyticsAccountSnapshot = {
  PLCN_HOMEDEPOT: 'plcc-account snapshot',
  PLNP_HOMEDEPOT: 'plcc-account snapshot-commercial',
  PLCR_HOMEDEPOT: 'plcc-account snapshot-commercial rev',
};

export const analyticsSelectAccount = {
  PLCN_HOMEDEPOT: 'plcc:select account:consumer',
  PLNP_HOMEDEPOT: 'plcc:select account:commercial',
  PLCR_HOMEDEPOT: 'plcc:select account:commercial rev',
};

export const defaultApplyNowLink = 'https://citiretailservices.citibankonline.com/CRS/acq/launch/index.action?app=UNSOL'
  + '&siteId=PLCN_HOMEDEPOT&sc=30005&cmp=A~H~8~C~8~A~ZZZ0~AI~HD~ZZ_1DT';
